module.exports = __webpack_public_path__ + "static/media/home_02.6685e782.svg";